/** SEO landing copy for /book-everest-base-camp-trek */

export const BOOK_EBC_SEO = {
	title: 'Book Everest Base Camp Trek Online',
	metaTitle: 'Book Everest Base Camp Trek Online — Nepal Group & Private Tours',
	description: 'Book an Everest Base Camp trek online with Visit All Nepal — group departures with fixed dates, private tours on your schedule, deposit payment, permits, Lukla flights, and verified local operators.',
	lead: 'Reserve your Everest Base Camp trek online — group departures, private tours, or plan first with our free step-by-step EBC guide.',
	sections: [
		{
			id: 'what-you-book',
			title: 'What you can book online',
			paragraphs: [
				'Visit All Nepal lets you book an Everest Base Camp (EBC) trek online — not a summit expedition to the top of Mount Everest (8,848 m), but the classic 12–14 day teahouse trek to Base Camp at 5,364 m. That is the most popular way millions of travelers experience the Everest region.',
				'Choose a group departure with fixed dates and pay a small deposit to reserve your seat, or request a private EBC trek on your own dates. We assign a verified local operator, confirm Lukla flights and permits, and stay available before and during your trip.',
			],
		},
		{
			id: 'included',
			title: 'Typical EBC trek inclusions',
			paragraphs: [
				'Most EBC packages include a licensed guide, porter (optional), teahouse accommodation, meals on trek, Sagarmatha National Park permit, TIMS card, and Lukla flights from Kathmandu. Exact inclusions are confirmed in writing before you travel.',
				'International flights, Nepal visa, travel insurance (required — must cover 5,500 m+ evacuation), tips, and personal gear are usually not included. Read our free EBC journey planner for a full packing list and budget breakdown.',
			],
		},
		{
			id: 'best-season',
			title: 'Best time to book EBC',
			paragraphs: [
				'Peak trekking seasons are March–May (spring, rhododendron blooms) and September–November (clearest skies). Group departures fill fastest for October. Book at least 2–3 months ahead for peak season Lukla flights.',
				'Monsoon (June–August) is not recommended for EBC — cloud, rain, and frequent flight delays. Winter is possible for experienced trekkers but cold and some passes may close.',
			],
		},
		{
			id: 'not-summit',
			title: 'EBC trek vs Everest summit climb',
			paragraphs: [
				'Searching "book Mount Everest climb" usually means a $40,000+ summit expedition with oxygen, fixed ropes, and 8–10 weeks — we do not offer that. We specialize in the EBC trek, Annapurna, Langtang, and Nepal travel planning.',
				'If EBC is your goal, you are in the right place. If you want the summit, contact a licensed expedition operator registered with the Nepal Mountaineering Association.',
			],
		},
	],
	faqs: [
		{
			q: 'Can I book Everest Base Camp trek online?',
			a: 'Yes — browse group departures or submit a private tour request on Visit All Nepal. Pay a deposit online to reserve; we confirm operator, dates, and inclusions within 1–2 business days.',
		},
		{
			q: 'How much does an EBC trek cost?',
			a: 'Budget roughly $1,200–2,500 USD per person for a standard 12–14 day teahouse trek including guide, permits, Lukla flights, and meals on trail — varies by group size, season, and comfort level.',
		},
		{
			q: 'Do I need experience to trek to Everest Base Camp?',
			a: 'You need good fitness and willingness to walk 5–7 hours daily at altitude. Prior trekking helps but many first-time trekkers complete EBC with proper acclimatization days built into the itinerary.',
		},
		{
			q: 'Is this the same as climbing Mount Everest?',
			a: 'No. EBC trek reaches 5,364 m on foot via teahouse trails. Summiting Everest (8,848 m) requires a separate expedition, technical climbing, and a much higher budget.',
		},
	],
};
